module.exports = __webpack_public_path__ + "static/img/BDJ.e878bd6f.png";